import { EnvironmentUrls } from 'Roblox';

const { billingApi, websiteUrl } = EnvironmentUrls;

export const getPremiumUrl = `${websiteUrl}/premium/membership?cashout=premium`;
export const getVerifyEmailUrl = `${websiteUrl}/my/account`;
export const getTermUrl = `${websiteUrl}/info/terms`;
export const getTermOfServiceUrl = `${websiteUrl}/developer-exchange/tos`;

export const getWelcomeDevexUrlConfig = () => ({
  withCredentials: true,
  url: `${billingApi}/v1/developer-exchange-metadata`
});
